import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { AnalyticsService } from '@rd/core/services/analytics/analytics.service';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'westpac-auth-secure-route-dialog',
  templateUrl: './auth-secure-route-dialog.component.html',
  styleUrls: ['./auth-secure-route-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WestpacAuthSecureRouteDialogComponent implements OnInit {
  @HostBinding('class.westpac-auth-secure-route-dialog') componentClass = true;

  constructor(
    private guardhouseService: GuardhouseService,
    private iconRegistryService: IconRegistryService,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
    this.analyticsService.track({
      routeName: 'login',
    });
  }

  registerIcons(): void {
    this.iconRegistryService.registerIcon('not-found');
  }

  redirectToLoginUrl(): void {
    this.guardhouseService.redirectToLoginUrl();
  }
}
